export function countTotalTime(time, format) {

    let seconds;
    if (typeof time === 'number') {
        
        const tmp = [secsToHHMMSS(time)];
        seconds = tmp.slice(1).reduce((prev, cur) => prev + timeStringToSecs(cur), timeStringToSecs(tmp[0]));
    } else {
        seconds = time.slice(1).reduce((prev, cur) => prev + timeStringToSecs(cur), timeStringToSecs(time[0]));
    };

    if (format === 'HH:mm:ss') {
        return secsToHHMMSS(seconds)
    } else if (format === 'HH:mm') {
        return secsToHHMM(seconds)
    } else {
        console.log('INVALID FORMAT IN countTotalTime');
        return 0;
    }
}

/**
 * Calculate orders production time
 */
export function getTotalProductionTime(startTime, productionTime, amount) {
    const startT = timeStringToSecs(startTime);
    const prodT = timeStringToSecs(productionTime)*parseFloat(amount);

    return secsToHHMM(startT+prodT);
}

export function timeStringToSecs(timeString) {
    if(!timeString) return 0;

const parts = timeString.split(':');
const hours = parseInt(parts[0])*3600;
const minutes = parseInt(parts[1])*60;
let seconds = 0;

if (parts.length == 3) {
seconds = parseInt(parts[2]);
}

return hours + minutes + seconds;
}

export function secsToHHMMSS(seconds) {

    var hours = Math.floor(seconds / 3600);
    var mins  = Math.floor(seconds / 60) % 60
    var secs  = Math.floor(seconds) % 60;

    if (hours < 10) hours = '0'+hours;
    if (mins < 10) mins = '0'+mins;
    if (secs < 10)secs = '0'+secs;
    return hours + ":" + mins + ":" + secs;
}

export function secsToHHMM(seconds) {

    var hours = Math.floor(seconds / 3600);
    var mins  = Math.floor(seconds / 60) % 60

    if (hours < 10) hours = '0'+hours;
    if (mins < 10) mins = '0'+mins;
    return hours + ":" + mins;
}

/**
 * Format number
 */
export function formatNumber(num) {

    return new Intl.NumberFormat('sv-SE', {
        style: 'currency',
        currency: 'SEK',
        maximumSignificantDigits: 5
    }).format(Math.round(num))
}

/**
 * Number to toKSEK
 */
 export function toKSEK(num) {

    if (num == 0) return num;

    var asDecimal = num /1000;
    var roundedAmount = Math.round(asDecimal) * 1000;

    var asCurrency = new Intl.NumberFormat('sv-SE', {
        style: 'currency',
        currency: 'SEK',
        maximumSignificantDigits: 10
    }).format(roundedAmount)

    return asCurrency.replace('000 kr', '');
}

/**
 * Locale DatePicker
 */

export const datepickerLocale = {
    sv: {
        months: [
            'Januari',
            'Februari',
            'Mars',
            'April',
            'Maj',
            'Juni',
            'Juli',
            'Augusti',
            'September',
            'Oktober',
            'November',
            'December',
        ],
        weekDays: [
            {
                name: 'Måndag',
                short: 'M',
            },
            {
                name: 'Tisdag',
                short: 'T',
            },
            {
                name: 'Onsdag',
                short: 'W',
            },
            {
                name: 'Torsdag',
                short: 'T',
            },
            {
                name: 'Fredag',
                short: 'F',
            },
            {
                name: 'Lördag',
                short: 'L',
                isWeekend: true,
            },
            {
                name: 'Söndag', // used for accessibility 
                short: 'S', // displayed at the top of days' rows
                isWeekend: true, // is it a formal weekend or not?
            }
        ],
        // just play around with this number between 0 and 6
        weekStartingIndex: 6,
        // return a { year: number, month: number, day: number } object
        getToday(gregorainTodayObject) {
            return gregorainTodayObject
        },
        // return a native JavaScript date here
        toNativeDate(date) {
            return new Date(date.year, date.month - 1, date.day)
        },
        // return a number for date's month length
        getMonthLength(date) {
            return new Date(date.year, date.month, 0).getDate()
        },
        // return a transformed digit to your locale
        transformDigit(digit) {
            return digit
        },
        // texts in the date picker
        nextMonth: 'Nästa månad',
        previousMonth: 'Förgående månad',
        openMonthSelector: 'Öppna månadsväljaren',
        openYearSelector: 'Öppna årsväljaren',
        closeMonthSelector: 'Stäng månadsväljaren',
        closeYearSelector: 'Stäng årsväljaren',
        defaultPlaceholder: 'Välj...',
        // for input range value
        from: 'Fr.',
        to: 'T.',
        // used for input value when multi dates are selected
        digitSeparator: ',',  
        // if your provide -2 for example, year will be 2 digited
        yearLetterSkip: 0,  
        // is your language rtl or ltr?
        isRtl: false,
    }
}

/**
 * Order status
 */

export function setOrderStatusClass(status) {
    let statusClass

    switch (status) {
        case 0:
            statusClass = 'not-started'
            break;
        case 1:
            statusClass = 'started'
            break;
        case 2:
            statusClass = 'done'
            break;
        case 3:
            statusClass = 'delayed'
            break;
        case 4:
            statusClass = 'delayed-delivered'
            break;
        default:
            statusClass = ''
            break;
    }

    return statusClass
}